module.exports = __webpack_public_path__ + "static/media/paragon-corp.98d5977b.png";